function init() {

    initializeQsmLogicEvaluateRuleFix();
    initializeQsmLogicDeferCheckboxEndQuiz();

    // Prevent QSM from throwing when qmn_quiz_data[quizID] is undefined (e.g. wrong/missing quiz ID)
    if (typeof window.qmn_quiz_data !== 'undefined' && window.qmn_quiz_data !== null && !window.__iccu_qmn_quiz_data_proxied) {
        window.qmn_quiz_data = new Proxy(window.qmn_quiz_data, {
            get(target, prop) {
                const val = target[prop];
                if (val === undefined && (typeof prop === 'string' || typeof prop === 'number')) {
                    return {
                        enable_quick_result_mc: 0,
                        enable_quick_correct_answer_info: 0,
                        end_quiz_if_wrong: 0,
                        disable_mathjax: 1,
                        quick_result_correct_answer_text: '',
                        quick_result_wrong_answer_text: '',
                        form_disable_autofill: 0
                    };
                }
                return val;
            }
        });
        window.__iccu_qmn_quiz_data_proxied = true;
    }

    // Check if the quiz container exists
    if (document.querySelector('.qsm-quiz-container')) {

        // Initialize loading overlay
        initializeLoadingOverlay();
        
        // Initialize question path tracking
        initializeQuestionPathTracking();
        
        // Watch for when the quiz results are injected into the DOM
        const observer = new MutationObserver((mutations) => {
            // Check if quiz container now exists
            if (document.querySelector('.qsm-results-page')) {
                initializeCompareFeature();
                initializeRevealFormButtons();
                initializeGravityFormsOnResultsPage();
                observer.disconnect(); // Stop observing once we've initialized

                document.body.classList.add('qsm-quiz-results-page');
            }
            
            // Update back buttons when questions appear
            updateBackButtons();
            updateNextButtons();
        });

        // Start observing the document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        // Update back buttons immediately in case questions are already loaded
        updateBackButtons();
        updateNextButtons();

        /**
         * Initialize loading overlay with spinner
         * Shows when navigating to next question or loading results
         */
        function initializeLoadingOverlay() {
            // Get all quiz containers (in case there are multiple)
            const quizContainers = document.querySelectorAll('.qsm-quiz-container');
            if (!quizContainers.length) return;
            
            // Create overlay for each quiz container
            quizContainers.forEach(quizContainer => {
                // Create overlay element
                const overlay = document.createElement('div');
                overlay.className = 'iccu-quiz-loading-overlay';
                // Use a more specific class to avoid QSM's cleanup removing it
                overlay.innerHTML = '<div class="qsm-spinner-loader iccu-quiz-spinner"></div>';
                overlay.style.display = 'none';
                
                // Append to quiz container
                quizContainer.appendChild(overlay);
            });
            
            // Helper function to show overlay
            function showOverlay(quizID) {
                const container = document.querySelector(`.qsm-quiz-container-${quizID}`);
                if (container) {
                    let overlayEl = container.querySelector('.iccu-quiz-loading-overlay');
                    if (!overlayEl) {
                        // Recreate overlay if it was removed
                        overlayEl = document.createElement('div');
                        overlayEl.className = 'iccu-quiz-loading-overlay';
                        overlayEl.innerHTML = '<div class="qsm-spinner-loader iccu-quiz-spinner"></div>';
                        container.appendChild(overlayEl);
                    } else {
                        // Check if spinner exists, recreate if QSM removed it
                        let spinner = overlayEl.querySelector('.qsm-spinner-loader, .iccu-quiz-spinner');
                        if (!spinner) {
                            overlayEl.innerHTML = '<div class="qsm-spinner-loader iccu-quiz-spinner"></div>';
                        }
                    }
                    overlayEl.style.display = 'flex';
                }
            }
            
            // Helper function to hide overlay
            function hideOverlay(quizID) {
                const container = document.querySelector(`.qsm-quiz-container-${quizID}`);
                if (container) {
                    const overlayEl = container.querySelector('.iccu-quiz-loading-overlay');
                    if (overlayEl) {
                        overlayEl.style.display = 'none';
                    }
                }
            }
            
            // Track when we're navigating back (to prevent overlay from showing)
            const backNavigationActive = {};
            
            // Show overlay immediately when radio button is selected
            quizContainers.forEach(quizContainer => {
                const quizID = quizContainer.className.match(/qsm-quiz-container-(\d+)/);
                if (!quizID) return;
                
                const quizIdNum = quizID[1];
                backNavigationActive[quizIdNum] = false;
                
                // Listen for radio button changes within this quiz container.
                // Scoped to .qsm-question-wrapper (not just any radio in the
                // container) because the results page - which uses this same
                // .qsm-quiz-container - can have a Gravity Form embedded in it
                // via the reveal-form-button feature; without this scope, a
                // radio selection on that form was also triggering the quiz's
                // loading overlay.
                jQuery(quizContainer).on('change', '.qsm-question-wrapper input[type="radio"]', function() {
                    // Don't show overlay if we're in the middle of back navigation
                    if (!backNavigationActive[quizIdNum]) {
                        showOverlay(quizIdNum);
                    }
                });
            });
            
            // Store backNavigationActive in a way that back button handler can access it
            window.iccuQuizBackNavigation = backNavigationActive;
            
            // Show overlay when next button is clicked (before navigation)
            jQuery(document).on('qsm_next_button_click_before', function(event, quizID) {
                showOverlay(quizID);
            });
            
            // Also listen for auto next button click (for paginated quizzes)
            jQuery(document).on('qsm_auto_next_button_click_before', function(event, quizID) {
                showOverlay(quizID);
            });
            
            // Hide overlay when page navigation completes
            jQuery(document).on('qsm_go_to_page_after', function(event, quizID, pageNumber) {
                // Small delay to ensure page is fully rendered
                setTimeout(() => {
                    hideOverlay(quizID);
                }, 100);
            });
            
            // Also hide after next button click completes
            jQuery(document).on('qsm_next_button_click_after', function(event, quizID) {
                setTimeout(() => {
                    hideOverlay(quizID);
                }, 200);
            });
            
            // Show overlay when quiz is being submitted (before results load)
            jQuery(document).on('qsm_before_quiz_submit', function(event, quiz_form_id) {
                const quizID = jQuery('#' + quiz_form_id).find('.qmn_quiz_id').val();
                showOverlay(quizID);
            });
            
            // Hide overlay when results are displayed
            jQuery(document).on('qsm_after_display_result', function(event, results, quiz_form_id, $container) {
                const quizID = jQuery('#' + quiz_form_id).find('.qmn_quiz_id').val();
                hideOverlay(quizID);
            });
            
            // Also hide on quiz submit (fallback)
            jQuery(document).on('qsm_after_quiz_submit', function(event, quiz_form_id) {
                // Small delay to ensure results have loaded
                setTimeout(() => {
                    const quizID = jQuery('#' + quiz_form_id).find('.qmn_quiz_id').val();
                    hideOverlay(quizID);
                }, 500);
            });
            
        }
        
        function initializeCompareFeature() {

            // Get references to the compare button and checkboxes
            const compareSelectedBtn = document.getElementById('quizCompareSelected');
            const compareOptions = document.querySelectorAll('.iccu-compare-option input[type="checkbox"]');

            // Only proceed if the button actually exists
            if (!compareSelectedBtn) {
                return;
            }

            // Grab translated strings from the button's data attributes
            const textCompare = compareSelectedBtn.dataset.textCompare;
            const textStop    = compareSelectedBtn.dataset.textStop;

            let compareActive = false;

            // Function to check if 2 or more checkboxes are checked
            function updateCompareButton() {
                const checkedCount = document.querySelectorAll('.iccu-compare-option input[type="checkbox"]:checked').length;
                
                if (checkedCount >= 2) {
                    compareSelectedBtn.classList.add('quiz-btn-active');
                } else {
                    compareSelectedBtn.classList.remove('quiz-btn-active');
                }
            }

            function resetCompare() {
                compareActive = false;

                // Reset button text and state
                compareSelectedBtn.textContent = textCompare;
                compareSelectedBtn.classList.remove('quiz-btn-active');

                // Uncheck all checkboxes
                compareOptions.forEach(checkbox => {
                    checkbox.checked = false;
                });

                // Hide comparison info
                document.querySelectorAll('.m-program-card__compare-info').forEach(el => {
                    el.style.display = 'none';
                });
                document.querySelectorAll('.m-program-card').forEach(el => {
                    el.classList.remove('card-compared');
                });

                // Toggled on the body rather than a specific results wrapper
                // element, so this works regardless of what markup a given
                // results page uses around its cards - no wrapper div required.
                document.body.classList.remove('iccu-quiz-comparing');
            }

            // Add change event listeners to all checkboxes
            compareOptions.forEach(checkbox => {
                checkbox.addEventListener('change', updateCompareButton);
            });

            compareSelectedBtn.addEventListener('click', (e) => {
                e.preventDefault();

                // If compare is already active, this button now acts as reset
                if (compareActive) {
                    resetCompare();
                    return;
                }

                // Only proceed if button has active class (i.e. 2+ checked)
                if (!compareSelectedBtn.classList.contains('quiz-btn-active')) {
                    return;
                }

                // Activate compare mode
                compareActive = true;
                compareSelectedBtn.textContent = textStop;

                // See the note in resetCompare() above on why this targets
                // body instead of a specific results wrapper element.
                document.body.classList.add('iccu-quiz-comparing');

                // Show comparison info on each selected card
                const checkedBoxes = document.querySelectorAll('.iccu-compare-option input[type="checkbox"]:checked');
                checkedBoxes.forEach(checkbox => {
                    const card = checkbox.closest('.m-program-card');
                    if (card) {
                        card.classList.add('card-compared');
                        const compareInfo = card.querySelector('.m-program-card__compare-info');
                        if (compareInfo) {
                            compareInfo.style.display = 'flex';
                        }
                    }
                });
            });
        }

        /**
         * Wires up %QUIZ_REVEAL_FORM_BUTTON% (config/quiz.php,
         * iccu_populate_reveal_form_button_variable()): each button reveals
         * the .iccu-reveal-form container it points to via
         * data-iccu-reveal-target, then hides itself since its job is done.
         */
        function initializeRevealFormButtons() {
            document.querySelectorAll('.iccu-reveal-form-button').forEach(function (button) {
                button.addEventListener('click', function (e) {
                    e.preventDefault();

                    const targetId = button.getAttribute('data-iccu-reveal-target');
                    const target = targetId ? document.getElementById(targetId) : null;

                    if (target) {
                        target.classList.add('iccu-reveal-form--visible');
                    }

                    button.classList.add('iccu-reveal-form-button--hidden');
                });
            });
        }

        /**
         * Gravity Forms server-renders any form with conditional logic
         * with its whole .gform_wrapper hidden via an inline style, and
         * normally removes it itself via a script that calls
         * gf_apply_rules() then .show()s the wrapper, once its
         * conditional_logic.js has evaluated the form's rules (see
         * config/quiz.php, iccu_enqueue_gravityforms_for_quiz_results()
         * for the full explanation and the primary fix - forcing GF's
         * scripts to load on the actual page instead of never at all).
         * This is a defensive fallback: if that inline style is still
         * stuck once the results page appears, clear it directly rather
         * than leave a form invisible with no way to know why.
         */
        function initializeGravityFormsOnResultsPage() {
            document.querySelectorAll('.gform_wrapper').forEach(function (wrapper) {
                if (wrapper.style.display === 'none') {
                    wrapper.style.display = '';
                }
            });
        }

        /**
         * Track the actual question path the user has taken
         * This accounts for questions skipped by the Logic addon
         * Only tracks questions when they become the active/current question
         */
        function initializeQuestionPathTracking() {
            // Get quiz ID from the container
            const quizContainer = document.querySelector('.qsm-quiz-container');
            if (!quizContainer) return;
            
            const quizIdMatch = quizContainer.className.match(/qsm-quiz-container-(\d+)/);
            if (!quizIdMatch) return;
            
            const quizId = quizIdMatch[1];
            const storageKey = `iccu_quiz_${quizId}_question_path`;
            
            // Initialize question path if it doesn't exist
            let questionPath = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
            
            /**
             * Track the current active question
             * Only tracks questions that are actually visible and active
             */
            function trackCurrentQuestion() {
                // Find questions that are actually visible and in view
                const allQuestions = Array.from(document.querySelectorAll('.qsm-question-wrapper[data-qid]'));
                
                // Find the question that's currently active/visible
                // Check for questions that are visible and not inside hidden containers
                let currentQuestion = null;
                
                for (let wrapper of allQuestions) {
                    const style = window.getComputedStyle(wrapper);
                    const rect = wrapper.getBoundingClientRect();
                    
                    // Question is visible if:
                    // 1. Display is not none
                    // 2. Visibility is not hidden
                    // 3. It has dimensions (is actually rendered)
                    // 4. It's not inside a hidden parent
                    if (style.display !== 'none' && 
                        style.visibility !== 'hidden' && 
                        rect.width > 0 && 
                        rect.height > 0 &&
                        !isInsideHiddenParent(wrapper)) {
                        currentQuestion = wrapper;
                        break; // Take the first visible one
                    }
                }
                
                if (!currentQuestion) return;
                
                const questionId = currentQuestion.getAttribute('data-qid');
                if (!questionId) return;
                
                // Get current path
                let currentPath = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
                
                // Only add if this is a new question (not the last one we tracked)
                if (currentPath.length === 0 || currentPath[currentPath.length - 1] !== questionId) {
                    // Remove this question if it's already in the path (handles back navigation)
                    const existingIndex = currentPath.indexOf(questionId);
                    if (existingIndex !== -1) {
                        // User went back - remove everything after this point
                        currentPath = currentPath.slice(0, existingIndex + 1);
                    } else {
                        // New question - add it to the path
                        currentPath.push(questionId);
                    }
                    sessionStorage.setItem(storageKey, JSON.stringify(currentPath));
                    updateBackButtons();
                    updateNextButtons();
                }
            }
            
            /**
             * Check if an element is inside a hidden parent
             */
            function isInsideHiddenParent(element) {
                let parent = element.parentElement;
                while (parent && parent !== document.body) {
                    const style = window.getComputedStyle(parent);
                    if (style.display === 'none' || style.visibility === 'hidden') {
                        return true;
                    }
                    parent = parent.parentElement;
                }
                return false;
            }
            
            // Track when page changes (QSM navigation)
            jQuery(document).on('qsm_go_to_page_after', function(event, quizID, pageNumber) {
                if (parseInt(quizID) === parseInt(quizId)) {
                    setTimeout(trackCurrentQuestion, 200);
                }
            });
            
            // Track when next button is clicked
            jQuery(document).on('qsm_next_button_click_after', function(event, quizID) {
                if (parseInt(quizID) === parseInt(quizId)) {
                    setTimeout(trackCurrentQuestion, 300);
                }
            });
            
            // Track when Logic addon triggers navigation
            jQuery(document).on('qsm_auto_next_button_click_after', function(event, quizID) {
                if (parseInt(quizID) === parseInt(quizId)) {
                    setTimeout(trackCurrentQuestion, 300);
                }
            });
            
            // Watch for DOM changes (for Logic addon jumps)
            const questionObserver = new MutationObserver(() => {
                // Debounce to avoid too many calls
                clearTimeout(questionObserver.timeout);
                questionObserver.timeout = setTimeout(trackCurrentQuestion, 300);
            });
            
            // Observe the quiz container for question changes
            questionObserver.observe(quizContainer, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style', 'class']
            });
            
            // Track initial question on load
            setTimeout(trackCurrentQuestion, 500);
        }
        
        /**
         * Update back buttons and start over links based on question path
         */
        function updateBackButtons() {
            const quizContainer = document.querySelector('.qsm-quiz-container');
            if (!quizContainer) return;
            
            const quizIdMatch = quizContainer.className.match(/qsm-quiz-container-(\d+)/);
            if (!quizIdMatch) return;
            
            const quizId = quizIdMatch[1];
            const storageKey = `iccu_quiz_${quizId}_question_path`;
            const questionPath = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
            
            // Find all back buttons
            const backButtons = document.querySelectorAll('.iccu-quiz-back-link');
            
            backButtons.forEach(button => {
                const currentQuestionId = button.getAttribute('data-question-id');
                if (!currentQuestionId) return;
                
                // Find the index of current question in the path
                const currentIndex = questionPath.indexOf(currentQuestionId);
                
                if (currentIndex > 0) {
                    // There's a previous question - show the back button
                    const previousQuestionId = questionPath[currentIndex - 1];
                    button.style.display = '';
                    button.setAttribute('data-previous-question-id', previousQuestionId);
                } else {
                    // This is the first question - hide the back button
                    button.style.display = 'none';
                }
            });
            
            // Find all start over links
            const startOverLinks = document.querySelectorAll('.iccu-quiz-start-over-link');
            
            startOverLinks.forEach(link => {
                const currentQuestionId = link.getAttribute('data-question-id');
                if (!currentQuestionId) return;
                
                // Find the index of current question in the path
                const currentIndex = questionPath.indexOf(currentQuestionId);
                
                if (currentIndex === 0) {
                    // This is the first question - hide the start over link
                    link.style.display = 'none';
                } else {
                    // Not the first question - show the start over link
                    link.style.display = '';
                }
            });
        }

        /**
         * Shows the custom "Next" link only for multiple-response
         * (checkbox) questions - QSM's own auto-advance (Quiz.js
         * initializeLoadingOverlay's change handler / QSM Ultimate's
         * goto_next_page) only applies to single-choice questions, so
         * these are the only pages with no other way to move forward.
         * See config/quiz.php, iccu_add_custom_question_html() for the
         * markup this toggles.
         */
        function updateNextButtons() {
            const nextLinks = document.querySelectorAll('.iccu-quiz-next-link');

            nextLinks.forEach(link => {
                const questionId = link.getAttribute('data-question-id');
                if (!questionId) return;

                const questionWrapper = document.querySelector(`.qsm-question-wrapper[data-qid="${questionId}"]`);
                const isMultiResponse = !!(questionWrapper && questionWrapper.querySelector('.qsm-multiple-response-input'));

                link.style.display = isMultiResponse ? '' : 'none';
            });
        }

        /**
         * Handle back button clicks
         * Uses QSM's navigation system instead of manually manipulating DOM
         */
        document.addEventListener('click', function(e) {
            const nextLink = e.target.closest('.iccu-quiz-next-link');
            if (nextLink) {
                e.preventDefault();
                e.stopPropagation();

                const quizContainer = e.target.closest('.qsm-quiz-container');
                if (!quizContainer) return;

                // If a Logic "end quiz" rule matched on this (multi-response)
                // question, initializeQsmLogicDeferCheckboxEndQuiz() deferred
                // firing it until now instead of the instant the first
                // checkbox was ticked. Flush it here rather than falling
                // through to the normal Next/Submit lookup below, since QSM's
                // own last-page-based button visibility has no idea this
                // question should end the quiz early.
                const quizIdMatch = quizContainer.className.match(/qsm-quiz-container-(\d+)/);
                const quizId = quizIdMatch ? quizIdMatch[1] : null;
                if (quizId && window.iccuPendingEndQuiz && window.iccuPendingEndQuiz[quizId]) {
                    delete window.iccuPendingEndQuiz[quizId];
                    jQuery(quizContainer).find('.qsm-submit-btn').trigger('click');
                    return;
                }

                // Trigger the real, hidden QSM Next/Submit button rather
                // than reimplementing page-advance ourselves - this keeps
                // QSM's own validation, animations, and Logic add-on
                // hooks all working exactly as they would from a real click.
                //
                // There's only one .qsm-pagination per quiz, rendered by
                // render_navigation_element outside the <form> - it is
                // NOT a sibling of .qsm-question-page, so DOM traversal
                // from the question page doesn't apply here. It holds
                // both the Next and Submit buttons at all times, each
                // starting with inline display:none; QSM's own
                // qsm-quiz-navigation.js shows/hides whichever is active
                // for the current page (Submit only on the last page) by
                // setting that inline style directly.
                //
                // .qsm-pagination itself is unconditionally display:none
                // in our CSS (it's replaced by our own Back/Next/Start
                // Over buttons), so jQuery's :visible can never match its
                // descendants - :visible checks the rendered box
                // (offsetWidth/offsetHeight), which is always zero under
                // a hidden ancestor regardless of a child's own inline
                // style. Read each button's own inline display instead of
                // relying on computed visibility.
                jQuery(quizContainer)
                    .find('.qsm-pagination')
                    .find('.qsm-next, .qsm-submit-btn')
                    .filter(function () {
                        return this.style.display !== 'none';
                    })
                    .first()
                    .trigger('click');
                return;
            }

            const backLink = e.target.closest('.iccu-quiz-back-link');
            if (backLink) {
                e.preventDefault();
                e.stopPropagation();
                
                const quizContainer = e.target.closest('.qsm-quiz-container');
                if (!quizContainer) return;
                
                const quizIdMatch = quizContainer.className.match(/qsm-quiz-container-(\d+)/);
                if (!quizIdMatch) return;
                
                const quizId = parseInt(quizIdMatch[1]);
                const storageKey = `iccu_quiz_${quizId}_question_path`;
                const questionPath = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
                
                const currentQuestionId = backLink.getAttribute('data-question-id');
                if (!currentQuestionId) return;
                
                // Find current question index in path
                const currentIndex = questionPath.indexOf(currentQuestionId);
                if (currentIndex <= 0) return; // Can't go back from first question
                
                // Get previous question ID
                const previousQuestionId = questionPath[currentIndex - 1];
                
                // Find the question wrapper for the previous question
                const previousQuestion = document.querySelector(`.qsm-question-wrapper[data-qid="${previousQuestionId}"]`);
                if (!previousQuestion) return;
                
                // Try to find which page contains this question and navigate to it
                if (typeof QSM !== 'undefined' && typeof QSM.goToPage === 'function') {
                    // Look for the page that contains this question
                    const questionPage = previousQuestion.closest('.qsm-page');
                    if (questionPage) {
                        // Get all pages and find the index of the one containing our question
                        const $quizForm = jQuery('#quizForm' + quizId);
                        const $pages = $quizForm.children('.qsm-page');
                        
                        let targetPageNumber = null;
                        $pages.each(function(index) {
                            if (jQuery(this).find(`.qsm-question-wrapper[data-qid="${previousQuestionId}"]`).length > 0) {
                                targetPageNumber = index + 1; // QSM uses 1-based page numbers
                                return false; // break
                            }
                        });
                        
                        if (targetPageNumber) {
                            // Mark that we're navigating back
                            if (window.iccuQuizBackNavigation) {
                                window.iccuQuizBackNavigation[quizId] = true;
                            }
                            
                            // Update path to reflect going back (remove current and everything after)
                            const newPath = questionPath.slice(0, currentIndex);
                            sessionStorage.setItem(storageKey, JSON.stringify(newPath));
                            
                            // Hide overlay immediately when going back
                            const container = document.querySelector(`.qsm-quiz-container-${quizId}`);
                            if (container) {
                                const overlayEl = container.querySelector('.iccu-quiz-loading-overlay');
                                if (overlayEl) {
                                    overlayEl.style.display = 'none';
                                }
                            }
                            
                            // Use QSM's navigation to go to that page
                            QSM.goToPage(quizId, targetPageNumber);
                            
                            // Scroll to the question after page loads and clear its answer
                            setTimeout(() => {
                                const question = document.querySelector(`.qsm-question-wrapper[data-qid="${previousQuestionId}"]`);
                                if (question) {
                                    // Clear radio button selection for this question
                                    const radioInputs = question.querySelectorAll('input[type="radio"]');
                                    radioInputs.forEach(radio => {
                                        radio.checked = false;
                                    });
                                    
                                    // Also clear any checkboxes
                                    const checkboxes = question.querySelectorAll('input[type="checkbox"]');
                                    checkboxes.forEach(checkbox => {
                                        checkbox.checked = false;
                                    });
                                    
                                    // Clear text inputs
                                    const textInputs = question.querySelectorAll('input[type="text"], textarea');
                                    textInputs.forEach(input => {
                                        input.value = '';
                                    });
                                    
                                    // Trigger change so QSM knows answers were cleared; catch plugin error if qmn_quiz_data[quizID] is undefined
                                    radioInputs.forEach(radio => {
                                        try {
                                            jQuery(radio).trigger('change');
                                        } catch (err) {
                                            // QSM may throw if qmn_quiz_data[quizID] is missing (e.g. enable_quick_result_mc)
                                        }
                                    });
                                    
                                    question.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                }
                                
                                // Ensure overlay is hidden
                                const containerEl = document.querySelector(`.qsm-quiz-container-${quizId}`);
                                if (containerEl) {
                                    const overlayEl = containerEl.querySelector('.iccu-quiz-loading-overlay');
                                    if (overlayEl) {
                                        overlayEl.style.display = 'none';
                                    }
                                }
                                
                                // Reset back navigation flag
                                if (window.iccuQuizBackNavigation) {
                                    window.iccuQuizBackNavigation[quizId] = false;
                                }
                                
                                updateBackButtons();
                                updateNextButtons();
                            }, 300);
                            return;
                        }
                    }
                }
                
                // Fallback: just scroll to the question if it's visible
                // Don't manipulate visibility - let QSM handle it
                const rect = previousQuestion.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) {
                    // Mark that we're navigating back
                    if (window.iccuQuizBackNavigation) {
                        window.iccuQuizBackNavigation[quizId] = true;
                    }
                    
                    // Hide overlay immediately when going back
                    const container = document.querySelector(`.qsm-quiz-container-${quizId}`);
                    if (container) {
                        const overlayEl = container.querySelector('.iccu-quiz-loading-overlay');
                        if (overlayEl) {
                            overlayEl.style.display = 'none';
                        }
                    }
                    
                    // Update path to reflect going back
                    const newPath = questionPath.slice(0, currentIndex);
                    sessionStorage.setItem(storageKey, JSON.stringify(newPath));
                    
                    // Clear radio button selection for this question
                    const radioInputs = previousQuestion.querySelectorAll('input[type="radio"]');
                    radioInputs.forEach(radio => {
                        radio.checked = false;
                    });
                    
                    // Also clear any checkboxes
                    const checkboxes = previousQuestion.querySelectorAll('input[type="checkbox"]');
                    checkboxes.forEach(checkbox => {
                        checkbox.checked = false;
                    });
                    
                                    // Clear text inputs
                                    const textInputs = previousQuestion.querySelectorAll('input[type="text"], textarea');
                                    textInputs.forEach(input => {
                                        input.value = '';
                                    });
                                    
                                    // Trigger change so QSM knows answers were cleared; catch plugin error if qmn_quiz_data[quizID] is undefined
                                    radioInputs.forEach(radio => {
                                        try {
                                            jQuery(radio).trigger('change');
                                        } catch (err) {
                                            // QSM may throw if qmn_quiz_data[quizID] is missing (e.g. enable_quick_result_mc)
                                        }
                                    });
                                    
                                    previousQuestion.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    
                    // Reset back navigation flag after a short delay
                    setTimeout(() => {
                        if (window.iccuQuizBackNavigation) {
                            window.iccuQuizBackNavigation[quizId] = false;
                        }
                        updateBackButtons();
                        updateNextButtons();
                    }, 100);
                }
            }
        });
    }
}

/**
 * Overrides QSM Logic add-on's own QSM_Logic_Quiz.evaluateRule() at
 * runtime with a corrected copy, fixing a bug in the plugin itself.
 *
 * WHY THIS LIVES HERE INSTEAD OF A PLUGIN PATCH: .pagely/pagelyignore
 * excludes every wp-content/plugins/qsm-* directory from all of this
 * project's Pagely git-deploy workflows (colabdev, colabstaging, master,
 * etc.) - confirmed directly against that file. A direct edit to the
 * plugin file can only ever reach an environment by hand-copying it
 * there; it can never travel through the normal deploy pipeline.
 * Overriding the function from theme JS instead means the fix ships with
 * every ordinary theme deploy, the same as any other change in this repo.
 * QSM_Logic_Quiz is declared with `var` above qsm-logic-quiz.js's own
 * IIFE (`var QSM_Logic_Quiz;` before `(function ($) {...})(jQuery)`), so
 * it's a genuine global and safely reassignable from here, after that
 * script has already run (this file's init() only runs on
 * DOMContentLoaded, which by definition fires after that plugin's normal,
 * non-deferred <script> tag has already executed).
 *
 * THE BUG: for the 'is not empty' condition, a question that hasn't
 * rendered on the page yet matches zero jQuery elements
 * ($question.length === 0). $question.val() on an empty jQuery selection
 * returns undefined, and '' !== undefined is true in JS - so a rule like
 * "SomeLaterQuestion is not empty -> endquiz" would spuriously fire the
 * instant ANY earlier question was answered, because
 * evaluateAndApplyAllRules() (also in qsm-logic-quiz.js) re-evaluates
 * every rule in the quiz on every single answer change, not just rules
 * referencing the question that was just answered.
 *
 * KNOWN LIMITATION: the original function's special handling for
 * "advanced" question types (16/17) calls
 * qsmCalculateAdvancedQuestionPoints() - a function private to
 * qsm-logic-quiz.js's own closure, never exposed for reuse, so it can't
 * be called from here. Guarded below so that specific, narrow case
 * degrades gracefully (skips the advanced-type point calculation)
 * instead of throwing. Not a concern for this site's quizzes today - none
 * use those types - but worth knowing if that ever changes.
 */
function initializeQsmLogicEvaluateRuleFix() {
    if (typeof QSM_Logic_Quiz === 'undefined' || typeof QSM_Logic_Quiz.evaluateRule !== 'function') {
        return;
    }

    QSM_Logic_Quiz.evaluateRule = function (rule) {
        question_names = "";
        var conditionsTrue = 0;
        var totalIf = 0;
        var grouped = _.mapObject(_.groupBy(rule.if, 'logic_level'), mylist => mylist.map(param => _.omit(param, 'logic_level')));

        jQuery.each(grouped, function (j, single) {
            conditionsTrue = 0;
            totalIf = 0;

            jQuery.each(single, function (i, val) {
                totalIf++;
                var $question = jQuery("input[name=question" + val.question + "]:checked, input[name='question" + val.question + "[]']:checked, select[name=question" + val.question + "], textarea[name=question" + val.question + "],input[name=question" + val.question + "][type='number'], input[name=question" + val.question + "][type='text']");

                var multipleCheckedVals = $question.map(function () {
                    return this.value;
                }).get();
                var is_checkbox = false;
                if ($question.is(':checkbox')) {
                    is_checkbox = true;
                }
                if ($question.is('select')) {
                    is_checkbox = true;
                }

                var questionType = '';
                var questionValue = '';

                if ($question.length == 0 && typeof qsm_logic_advanced_questions !== 'undefined' && qsm_logic_advanced_questions && qsm_logic_advanced_questions[val.question] && [16, 17].includes(parseInt(qsm_logic_advanced_questions[val.question]['type']))) {
                    var current_q_name = "input[name^='" + val.question + "-']";
                    if (question_names != "") {
                        question_names += ",";
                    }
                    question_names += current_q_name;
                    $question = jQuery(current_q_name);

                    if ($question.parents('.quiz_section').attr('class')) {
                        var matches = $question.parents('.quiz_section').attr('class').match(/question-type-(\d+)/);
                        if (matches) {
                            questionType = matches[1];
                        }
                    }
                    if ([16, 17].includes(parseInt(questionType)) && typeof qsmCalculateAdvancedQuestionPoints === 'function') {
                        var selectedValues = $question.parents('.quiz_section').find('input[type="radio"]:checked,input[type="checkbox"]:checked').map(function () {
                            return this.id;
                        }).get();
                        questionValue = qsmCalculateAdvancedQuestionPoints(val.question, selectedValues);
                    }
                }

                if ("No Answer Provided" != $question.val()) {
                    switch (val.condition) {
                        case 'is equal to':
                            if (![16, 17].includes(parseInt(questionType)) && ($question.val() === decodeEntities(val.answer).toString() || multipleCheckedVals.includes(decodeEntities(val.answer).toString()))) {
                                conditionsTrue++;
                            } else if ([16, 17].includes(parseInt(questionType)) && questionValue == val.answer) {
                                conditionsTrue++;
                            }
                            break;
                        case 'is not equal to':
                            if (![16, 17].includes(parseInt(questionType)) && $question.val() !== decodeEntities(val.answer).toString() && !is_checkbox) {
                                conditionsTrue++;
                            }
                            if (is_checkbox && ![16, 17].includes(parseInt(questionType))) {
                                if (jQuery.inArray(decodeEntities(val.answer).toString(), multipleCheckedVals) === -1) {
                                    conditionsTrue++;
                                }
                            }
                            if ([16, 17].includes(parseInt(questionType)) && questionValue != val.answer) {
                                conditionsTrue++;
                            }
                            break;
                        case 'is greater than':
                            if (![16, 17].includes(parseInt(questionType)) && parseFloat($question.val()) > parseFloat(decodeEntities(val.answer)) && !is_checkbox) {
                                conditionsTrue++;
                            }
                            if (is_checkbox && ![16, 17].includes(parseInt(questionType))) {
                                var check_g_gt = false;
                                jQuery.each(multipleCheckedVals, function (k, v) {
                                    if (parseFloat(v) > parseFloat(decodeEntities(val.answer))) {
                                        check_g_gt = true;
                                    }
                                });
                                if (check_g_gt) {
                                    conditionsTrue++;
                                }
                            }
                            if ([16, 17].includes(parseInt(questionType)) && parseFloat(questionValue) > parseFloat(decodeEntities(val.answer))) {
                                conditionsTrue++;
                            }
                            break;
                        case 'is less than':
                            if (![16, 17].includes(parseInt(questionType)) && parseFloat($question.val()) < parseFloat(decodeEntities(val.answer)) && !is_checkbox) {
                                conditionsTrue++;
                            }
                            if (is_checkbox && ![16, 17].includes(parseInt(questionType))) {
                                var check_g_lt = false;
                                jQuery.each(multipleCheckedVals, function (k, v) {
                                    if (parseFloat(v) < parseFloat(decodeEntities(val.answer))) {
                                        check_g_lt = true;
                                    }
                                });
                                if (check_g_lt) {
                                    conditionsTrue++;
                                }
                            }
                            if ([16, 17].includes(parseInt(questionType)) && parseFloat(questionValue) < parseFloat(decodeEntities(val.answer))) {
                                conditionsTrue++;
                            }
                            break;
                        case 'is empty':
                            if (![16, 17].includes(parseInt(questionType)) && ('' === $question.val() || null === $question.val())) {
                                conditionsTrue++;
                            }
                            if (!is_checkbox && 0 === multipleCheckedVals.length) {
                                conditionsTrue++;
                            }
                            break;
                        case 'is not empty':
                            if (is_checkbox) {
                                if (multipleCheckedVals.length > 0) {
                                    conditionsTrue++;
                                }
                            } else if (![16, 17].includes(parseInt(questionType)) && $question.length > 0 && '' !== $question.val()) {
                                // The actual fix: require the question to
                                // exist on the page at all before treating
                                // it as "not empty".
                                conditionsTrue++;
                            }
                            break;
                        default:
                            // default
                    }
                }
            });

            if (conditionsTrue === totalIf) {
                return false; // jQuery.each: break out - a fully-matched OR-group is enough
            }
        });

        return (conditionsTrue === totalIf);
    };
}

/**
 * Overrides QSM Logic's QSM_Logic_Quiz.evaluateAndApplyAllRules() (same
 * runtime-override approach as initializeQsmLogicEvaluateRuleFix() above,
 * for the same .pagelyignore reason - see that function's comment) to fix
 * a UX problem rather than an outright bug: a Logic rule like "[multi-
 * response question] is not empty -> end quiz" was ending the quiz the
 * instant the visitor ticked the FIRST checkbox, even on a question that
 * allows selecting more than one (e.g. "select up to two") - because
 * evaluateAndApplyAllRules() re-evaluates and acts on every rule on every
 * single answer change, with no concept of "the visitor might not be done
 * with this question yet".
 *
 * This is exactly the same reason multi-response questions get our own
 * custom Next link instead of auto-advancing (see updateNextButtons() /
 * the .iccu-quiz-next-link click handler below) - checkbox questions need
 * an explicit "I'm done" signal from the visitor. This extends that same
 * idea to Logic's end-quiz action: for a rule whose IF-source question is
 * multi-response, defer the actual "end the quiz" (the
 * .qsm-submit-btn click) until that Next link is clicked, instead of
 * firing it immediately. Non-checkbox-sourced rules are completely
 * unaffected - they still end the quiz immediately, exactly as before.
 *
 * Faithful copy of the original function with only two changes, each
 * marked below: resetting window.iccuPendingEndQuiz at the top (so a
 * later un-checking of every box correctly cancels a previously-deferred
 * end-quiz), and branching the final endQuizRule handling on whether its
 * IF-source question is multi-response. The .iccu-quiz-next-link click
 * handler below checks window.iccuPendingEndQuiz before its normal
 * find-the-visible-button logic and, if set, triggers the real submit
 * button directly - the same action this function would have taken
 * immediately if not deferred.
 */
function initializeQsmLogicDeferCheckboxEndQuiz() {
    if (typeof QSM_Logic_Quiz === 'undefined' || typeof QSM_Logic_Quiz.evaluateAndApplyAllRules !== 'function') {
        return;
    }

    QSM_Logic_Quiz.evaluateAndApplyAllRules = function () {
        var desiredState = {};
        var endQuizRule = null;

        // CHANGE 1 of 2: reset on every pass, so unchecking a box after an
        // earlier tick correctly cancels a previously-deferred end-quiz
        // rather than leaving it stuck true.
        window.iccuPendingEndQuiz = {};

        jQuery.each(qmn_quiz_data_new, function (quizIndex, rules) {
            if (qmn_quiz_data[quizIndex] && qmn_quiz_data[quizIndex].pagination && qmn_quiz_data[quizIndex].pagination.amount > 0) {
                return;
            }

            var matchedIfSources = {};
            jQuery.each(rules, function (ruleIndex, rule) {
                rule._conditionsMet = QSM_Logic_Quiz.evaluateRule(rule);
                if (rule._conditionsMet) {
                    jQuery.each(rule.if, function (ci, cond) {
                        matchedIfSources[String(cond.question)] = true;
                    });
                }
            });

            jQuery.each(rules, function (ruleIndex, rule) {
                var conditionsMet = rule._conditionsMet;

                var ifSourceIds = {};
                jQuery.each(rule.if, function (ci, cond) {
                    ifSourceIds[String(cond.question)] = true;
                });

                var skipInverse = false;
                if (!conditionsMet) {
                    jQuery.each(rule.if, function (ci, cond) {
                        if (matchedIfSources[String(cond.question)]) {
                            skipInverse = true;
                            return false;
                        }
                    });
                }

                if (!conditionsMet && skipInverse) {
                    return;
                }

                jQuery.each(rule.then, function (i, action) {
                    if (action.condition === 'goto') return;

                    if (action.condition === 'endquiz') {
                        if (conditionsMet) endQuizRule = rule;
                        return;
                    }

                    var targetId = action.question;
                    var intendedAction;

                    if (conditionsMet) {
                        intendedAction = action.condition;
                    } else {
                        intendedAction = (action.condition === 'Show') ? 'Hide' : 'Show';
                    }

                    if (intendedAction === 'Hide' && ifSourceIds[String(targetId)]) {
                        return;
                    }

                    if (desiredState[targetId] !== undefined && !conditionsMet) {
                        return;
                    }

                    desiredState[targetId] = intendedAction;
                });
            });
        });

        QSM_End_Quiz = false;

        jQuery.each(desiredState, function (targetId, action) {
            var sectionClass = '.question-section-id-' + targetId;
            if (String(targetId).indexOf('c') > -1) {
                sectionClass = '.category-section-id-' + targetId;
            }

            var $el = jQuery(sectionClass);
            var wasHidden = $el.hasClass('qsm-logic-hidden');

            if (jQuery(".data-req-el-" + targetId).length) {
                jQuery.each(jQuery(".data-req-el-" + targetId), function () {
                    var req_class = jQuery(this).attr("data-req-class");
                    jQuery(this).addClass(req_class);
                });
            }

            if (action === 'Show') {
                $el.show().removeClass('qsm-logic-hidden');
                removeFromHiddenField(targetId);
            } else {
                if (!wasHidden) {
                    resetBeforeHide(targetId);
                }
                $el.hide().addClass('qsm-logic-hidden');
                qsmRemoveRequired(sectionClass + ' *', sectionClass, targetId);
                addToHiddenField(targetId);
            }
        });

        if (endQuizRule) {
            QSM_End_Quiz = true;
            if (endQuizRule.if[0] && endQuizRule.if[0].question) {
                var $ifQuestion = jQuery(document).find('.question-section-id-' + endQuizRule.if[0].question);
                var quizId = $ifQuestion.parents('.qsm-quiz-container').find('.qmn_quiz_id').val();

                // CHANGE 2 of 2: defer for multi-response IF-source
                // questions instead of ending the quiz immediately.
                if ($ifQuestion.find('.qsm-multiple-response-input').length > 0) {
                    window.iccuPendingEndQuiz[quizId] = true;
                } else {
                    jQuery(document).find('.qsm-quiz-container-' + quizId + ' .qsm-submit-btn').trigger('click');
                }
            }
        }

        QSMLogicRecalucateQuestionNumber();
    };
}

export { init as default }